import { Attributes } from 'react';
import useResponsiveScreen from '../hooks/useResponsiveScreen';

export function EmptyComponent() {
  return null;
}

export function withWebResponsiveDesign<T extends Attributes>(
  MobileComponent: React.ComponentType<T> | undefined = EmptyComponent,
  TabletComponent?: React.ComponentType<T>,
  SmallDesktopComponent?: React.ComponentType<T>,
  LargeDesktopComponent?: React.ComponentType<T>,
) {
  return (props: T) => {
    const { isTablet, isSmallDesktop, isLargeDesktop } = useResponsiveScreen();

    let Component;
    if (isLargeDesktop) {
      Component = LargeDesktopComponent ?? SmallDesktopComponent ?? TabletComponent ?? EmptyComponent;
    } else if (isSmallDesktop) {
      Component = SmallDesktopComponent ?? TabletComponent ?? EmptyComponent;
    } else if (isTablet) {
      Component = TabletComponent ?? EmptyComponent;
    } else {
      Component = MobileComponent;
    }

    return <Component {...props} />;
  };
}
